import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-end justify-center overflow-hidden pb-44">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/a1608ffe9637dec43a03071f0c05c7e6.webp"
          alt="おかやま美容室 - 岡山市の上質な美容室"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 w-full max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-[2.75rem] lg:text-[2.75rem] font-bold text-white mb-6 tracking-wider leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          あなたらしい<span style={{ color: '#8BA76A' }}>美しさ</span>を見つけませんか
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white mb-8 sm:mb-12 leading-relaxed max-w-2xl mx-auto" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
          岡山市で愛される美容室。丁寧なカウンセリングと<br className="hidden sm:block" />確かな技術で、理想のヘアスタイルを実現します。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="tel:086-012-3456"
            className="inline-flex items-center px-8 py-4 bg-primary text-white text-sm font-semibold rounded-full hover:bg-primary/90 transition-all duration-300 shadow-lg whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
            086-012-3456
          </a>
          <Link
            to="/contact"
            className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white text-sm font-semibold rounded-full hover:bg-white hover:text-sub transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            <i className="ri-mail-line mr-2 w-5 h-5 flex items-center justify-center"></i>
            お問い合わせ
          </Link>
        </div>
      </div>
    </section>
  );
}
